import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});

interface Iresponse {
  status: boolean;
  lab_partner_id: string | null;
}
export const useLabAddPartnerAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const configuration = useConfiguration();
  const execute = useCallback(
    async (items: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: Iresponse = await axios
          .post(`${LAB_REPORT?.ADD_LAB_PARTNER_NAME?.baseURL}`, items, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              return { status: true, lab_partner_id: res.data?.data };
            } else {
              return { status: false, lab_partner_id: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            return { status: false, lab_partner_id: null };
          });
        return response;
      } catch (e: any) {
        //
      }
    },
    [dispatch],
  );
  return { execute };
};
